import React from 'react'
import {Flex} from '/app/src/component'
import { connect } from 'react-redux'
import SVG from 'react-inlinesvg'
import Jibber from '/app/src/jibber'
import {List} from 'immutable'
import {history} from '/app/src/store'
import Hint from '/app/src/component/Hint';

import {FeedbackModel, FAQModel, FeedbackSelector} from '/app/src/model'
import * as FAQSelector from '/app/src/model/FAQ/selector';

//Styles
import Theme from '/app/src/theme';
import style from './style.css';


class FeedbackOverview extends Jibber{

    constructor(props) {

        super(props);

        this.useState({
            sortingKey: 'positive',
            hover: '',
            nbrUnread: 0
        })

        this._renderHeader = this._renderHeader.bind(this);
        this.getNbrUnread = this.getNbrUnread.bind(this);


    }

    componentDidMount(){
        const {sortingKey} = this.state;

        this.props.readItems();
        this.props.dispatchQuestions('helpdesk', sortingKey, 1);
        this.props.getUnread('helpdesk', this.getNbrUnread);
    }

    componentDidUpdate(prevProps, prevState){
        const {sortingKey} = this.state;

        if(sortingKey !== prevState.sortingKey){
            this.props.dispatchQuestions('helpdesk', sortingKey, 1);
        }
    }

    getNbrUnread(nbrUnread){
        if(this.state.nbrUnread !== nbrUnread && nbrUnread < 100){
            this.setNbrUnread(nbrUnread);
        }

    }

    _renderHeader(){
        const {hover, nbrUnread} = this.state;
        const questionIcon = <SVG style={{fill: Theme.colors.pink}} className={style.Icon} src='/images/Menu_ClientChat_Helpdesk_L.svg' cacheGetRequests={true}/>
        const inboxIcon = <SVG style={{fill: Theme.colors.black}} className={style.Icon} src='/images/FeedbackInbox_M.svg' cacheGetRequests={true}/>
        const rightArrowIcon = <SVG style={{fill: '#2ea2d2'}} className={style.ArrowIcon} src='/images/ArrowDirection_Right_S.svg' cacheGetRequests={true}/>

        const HeaderTextProps = {
            vAlignContent: 'center',
            color: hover === 'question'?'darkblue': '',
            className: style.HeaderText,
            width: '330px',
            onMouseEnter: ()=>this.setHover('question'),
            onMouseLeave: ()=>this.setHover(''),
            onClick: () => history.push('/clientChat/faq/helpdesk/feedback/questions'),
        }


        return(
            <Flex vAlignContent='center' position='relative' grow>
                <Flex vAlignContent='center' cursor='pointer' grow>
                    <Flex {...HeaderTextProps}>
                        <Flex mr='5px' vAlignContent='center'>
                            {questionIcon}
                        </Flex>
                        <Flex vAlignContent='center'>
                            Helpdesk Feedback
                        </Flex>
                        {
                            (hover === 'question') &&
                            <Flex vAlignContent='center'>
                                {rightArrowIcon}
                            </Flex>
                        }
                    </Flex>
                    <Flex vAlignContent='center'
                        className={style.HeaderText}
                        color={(hover === 'inbox' ? '#2ea2d2' : '')}
                        onMouseEnter={() => this.setHover('inbox')}
                        onMouseLeave={() => this.setHover('')}
                        onClick={() => history.push('/clientChat/faq/helpdesk/feedback/posts')}
                    >
                        <Flex mr='5px'>
                            {inboxIcon}
                        </Flex>
                        <Flex position='relative'>
                            Inkorg
                            { (nbrUnread > 0) &&
                                <Flex className={style.NumberUnread} center>
                                    {nbrUnread}
                                </Flex>
                            }
                        </Flex>
                        {
                            (hover === 'inbox') &&
                            <Flex vAlignContent='center'>
                                {rightArrowIcon}
                            </Flex>
                        }
                    </Flex>
                </Flex>
                <Flex hAlignContent='right' className={style.HintIcon}>
                    <Hint position='right' tooltip='Se hur era helpdesk-frågor presterar.' height='26px' width='26px'/>
                </Flex>
            </Flex>
        )
    }

    _renderSortButton(icon, sortingKey){

        let borderBottom = {borderBottom: '3px solid transparent'};;
        if(this.state.sortingKey === sortingKey){
            borderBottom = {borderBottom: '3px solid #2ea2d2'};
        }

        return (
            <Flex center className={style.ButtonContainer}
                    onClick={() => this.setSortingKey(sortingKey)}
                    style={borderBottom}>
                <Flex shrink={0}>
                    {icon}
                </Flex>
            </Flex>
        )
    }

    _renderSmileys(){
        const posIcon = <SVG style={{fill: Theme.colors.green1}}
                className={style.IconSmiley}
                src='/images/emojiSmile2.svg'
                cacheGetRequests={true}
                />
        const postsIcon = <SVG style={{fill: Theme.colors.grey2}} className={style.IconSmiley} src='/images/Conversations_M.svg' cacheGetRequests={true}/>
        const negIcon = <SVG style={{fill: Theme.colors.red1}} className={style.IconSmiley} src='/images/emojiUnhappy.svg' cacheGetRequests={true}/>

        return(
            <Flex>
                {this._renderSortButton(posIcon, 'positive')}
                {this._renderSortButton(negIcon, 'negative')}
                {this._renderSortButton(postsIcon, 'discussed')}
            </Flex>
        )
    }

    _renderFeedbackList(){

        const {questions, feedbackStats, order} = this.props;
        const questionList = []

        for (let i = 0; i < order.size && i < 5; i++){

        const questionId = order.get(i).toString()
        const question = questions.getIn([questionId, 'question']);
        const nbrPositive = feedbackStats[questionId]['positive'];
        const nbrNegative = feedbackStats[questionId]['negative'];
        const nbrDiscussed = feedbackStats[questionId]['discussed'];
        questionList.push(
                <Flex grow bg='grey1' className={style.FeedbackItem} key={i}>
                    <Flex className={style.SmileyNumbers} color='green1'>
                        {nbrPositive}
                    </Flex>
                    <Flex className={style.SmileyNumbers} color='red1'>
                        {nbrNegative}
                    </Flex>
                    <Flex className={style.SmileyNumbers} color='grey2'>
                        {nbrDiscussed}
                    </Flex>
                    <div className={style.Question}>
                        {question}
                    </div>
                </Flex>
            )
        }

        return questionList;

    }

    render(){

        const {questions} = this.props;

        if(questions.size === 0){
            return null;
        }

        return(
            <Flex grow column className={style.FeedbackContainer}>
                {this._renderHeader()}
                {this._renderSmileys()}
                {this._renderFeedbackList()}
            </Flex>
        );
    }
}

const {selector: questionsSelector, dispatcher: dispatchQuestions} = FeedbackModel.readQuestions();
const {dispatcher: readItems } = FAQModel.readItemsRequest()
const {dispatcher: getUnread} = FeedbackModel.getUnread();


const mapDispatchToProps = (dispatch, props) => {
    return {
        'readItems': () => { dispatch(readItems()) },
        'dispatchQuestions': (systemType, sortingKey, offset) => dispatch(dispatchQuestions(systemType, sortingKey, offset)),
        'dispatchCurrentItem': (currentItem) => dispatch(FeedbackModel.setCurrentItem(currentItem)),
        'getUnread': (systemType, callback) => dispatch(getUnread(systemType, callback))

    }

}

function _countFeedback(feedback) {
    const feedbackArray = {}
    for (let i = 0; i < feedback.size; i++) {
        const currentFeedback = feedback.get(i)
        const questionId = FeedbackSelector.getFeedbackSystemId(currentFeedback)
        const rating = FeedbackSelector.getFeedbackRating(currentFeedback)
        const hasDiscussed = FeedbackSelector.hasDiscussed(currentFeedback);
        if (!(questionId in feedbackArray)) {
            feedbackArray[questionId] = {}
            feedbackArray[questionId]['positive'] = 0;
            feedbackArray[questionId]['negative'] = 0;
            feedbackArray[questionId]['discussed'] = 0;
        }
        if (rating === 1) feedbackArray[questionId]['positive']++
        else if (rating === -1) feedbackArray[questionId]['negative']++

        if(hasDiscussed){
            feedbackArray[questionId]['discussed']++;
        }
    }
    return feedbackArray
}

function mapStateToProps(state, props) {
    let feedback = questionsSelector(state, 'helpdesk')
    const questionsCount = feedback.getIn(['questions', 'questions_total']);

    const order = feedback.getIn(['questions', 'order'], List([]))
    feedback = feedback.getIn(['questions', 'feedbacks'], List([]))
    const questions = FAQSelector.getFAQs(state);
    const feedbackStats = _countFeedback(feedback);
    const currentItem = FeedbackSelector.getCurrentItem(state);



    return { feedback, order, questions, feedbackStats, questionsCount, currentItem}
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackOverview)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Overview/Feedback/index.js